import { render } from "./RaceHistoryItem.vue?vue&type=template&id=71b5ee94"
import script from "./RaceHistoryItem.vue?vue&type=script&lang=js"
export * from "./RaceHistoryItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__